import { render, staticRenderFns } from "./vendorNew.vue?vue&type=template&id=4e0e8c10&"
import script from "./vendorNew.vue?vue&type=script&lang=js&"
export * from "./vendorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports